import styled from "styled-components";
import { colors, media } from "../system";

export const Card = styled.div`
  background: ${colors.white};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${media.mobileOnly`
    min-height: calc(100vh - 80px);
  `}

  ${media.tablet`
    height: auto;
  `};

  ${media.desktop`
    padding: 26px 80px 35px;
    border-radius: 24px;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.08), 0 24px 32px 0 rgba(0, 0, 0, 0.04);
  `};
`;
